import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=40838686&"
import script from "./AlarmInfo.vue?vue&type=script&lang=js&"
export * from "./AlarmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports